import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-wrap items-center gap-4" }
const _hoisted_2 = { class: "flex justify-center" }

import { computed } from 'vue'
import LegendTable, { ELegendColor } from '@/components/others/Legend.vue'
import LegendsModal from './legends.modal.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { mdiMapLegend } from '@mdi/js'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { COVERAGE_STATUS_SHORT_LABELS } from '@/utils/coverage'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import { useLegendShowsUnidentified } from './useLegendShowsUnidentified'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const modalStore = useModalStore()

const showUnidentified = useLegendShowsUnidentified()

const baseLegends = [
  { text: 'Aberta', color: ELegendColor.alert },
  { text: 'Fixo', color: ELegendColor.default },
  { text: 'Cobertura', color: ELegendColor.warning },
  { text: 'Extra', color: ELegendColor.success }
]

// "Ocupado s/ ident." só quando a resposta conhece o estado (mesma regra da legenda V2).
const legends = computed(() =>
  showUnidentified.value
    ? [
        ...baseLegends,
        {
          text: COVERAGE_STATUS_SHORT_LABELS[CoverageStatus.UNIDENTIFIED],
          color: ELegendColor.unidentified
        }
      ]
    : baseLegends
)

const showAllLegends = () => {
  modalStore.toggleModal(EModals.LEGENDS)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(legends.value, (legend, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "hidden md:flex justify-start px-1"
        }, [
          _createVNode(LegendTable, {
            legendColor: legend.color,
            text: legend.text
          }, null, 8, ["legendColor", "text"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(GhostButton, {
          text: "Ver legenda completa",
          width: "100%",
          density: "compact",
          prependIcon: _unref(mdiMapLegend),
          onClick: showAllLegends
        }, null, 8, ["prependIcon"])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(LegendsModal)
    ]))
  ], 64))
}
}

})